import { isValidUrl } from 'utils/isValidUrl/isValidUrl';

const validateUrl = (label: string, value: string): string | undefined => (isValidUrl(value) ? undefined : label);

type urlType = object | string;

export const isAllValidUrl = (label: string, key?: string) => (values: urlType[]) => {
  return values.reduce<string | undefined>((error, currentValue) => {
    const value = key ? currentValue[key] : currentValue;

    return error || validateUrl(label, value);
  }, undefined);
};
